// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2eCZq","bigColWidth":"Table_bigColWidth__3Y2kY","biggerColWidth":"Table_biggerColWidth__1aUFV","row":"Table_row__I5NfX","col":"Table_col__1RYQn"};